// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.array.group",
  "esnext.array.group-to-map",
  "esnext.array.to-reversed",
  "esnext.array.to-sorted",
  "esnext.array.to-spliced",
  "esnext.array.with",
  "esnext.typed-array.to-reversed",
  "esnext.typed-array.to-sorted",
  "esnext.typed-array.with",
]);
